import { FC, MouseEventHandler } from 'react'
import PerButton, { PerButtonProps } from '../../../components/custom_components/Button'
import { IconNames } from '../../../components/util/types'

interface PerActionButtonProps extends PerButtonProps {
  icon?: IconNames
  clickHandler?: MouseEventHandler
}

export const PerActionButton: FC<PerActionButtonProps> = ({ icon, clickHandler, ...props }) => {
  return (
    <PerButton onClick={clickHandler} variant="pastel" before={icon} size="small" width="fullWidth" disabled={!clickHandler} {...props} />
  )
}
